import React from 'react';
import { COLORS } from '../../constants';

export const EmergentAIcon = (): JSX.Element => {
  return (
    <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="27" cy="27" r="26" fill="#E5145B" stroke="#fff" strokeWidth="2" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.415 36.97c-.37.32-.795.48-1.275.48-.32 0-.62-.085-.9-.255-.28-.17-.5-.435-.66-.795l-1.8-4.02H22.22l-1.8 4.02c-.16.36-.38.625-.66.795-.28.17-.59.255-.93.255-.46 0-.88-.16-1.26-.48-.38-.32-.57-.71-.57-1.17 0-.26.06-.52.18-.78l8.28-17.79c.18-.4.455-.705.825-.915.37-.21.765-.315 1.185-.315.42 0 .815.105 1.185.315.37.21.645.515.825.915l8.31 17.79c.12.26.18.52.18.78 0 .46-.185.85-.555 1.17zM27.5 20.47l-3.96 8.91h7.92l-3.96-8.91z"
        fill="#fff"
      />
    </svg>
  );
};

export const EmergentBIcon = (): JSX.Element => {
  return (
    <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="27" cy="27" r="26" fill="#FCE3EE" stroke={COLORS.debianRed} strokeWidth="2" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.6 37.15c2.26 0 4.035-.51 5.325-1.53s1.935-2.43 1.935-4.23c0-1.3-.335-2.4-1.005-3.3-.67-.9-1.615-1.52-2.835-1.86 1.04-.38 1.855-.98 2.445-1.8.59-.82.885-1.79.885-2.91 0-1.74-.625-3.095-1.875-4.065C32.225 16.485 30.5 16 28.3 16h-7.44c-.58 0-1.035.16-1.365.48-.33.32-.495.77-.495 1.35v17.49c0 .58.165 1.03.495 1.35.33.32.785.48 1.365.48h7.74zm-.93-12.24h-4.89V19h4.89c1.34 0 2.34.24 3 .72.66.48.99 1.22.99 2.22 0 1.98-1.33 2.97-3.99 2.97zm-4.89 9.24h5.4c1.4 0 2.42-.25 3.06-.75.64-.5.96-1.28.96-2.34 0-1.06-.325-1.85-.975-2.37-.65-.52-1.665-.78-3.045-.78h-5.4v6.24z"
        fill="ivory"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.6 37.15c2.26 0 4.035-.51 5.325-1.53s1.935-2.43 1.935-4.23c0-1.3-.335-2.4-1.005-3.3-.67-.9-1.615-1.52-2.835-1.86 1.04-.38 1.855-.98 2.445-1.8.59-.82.885-1.79.885-2.91 0-1.74-.625-3.095-1.875-4.065C32.225 16.485 30.5 16 28.3 16h-7.44c-.58 0-1.035.16-1.365.48-.33.32-.495.77-.495 1.35v17.49c0 .58.165 1.03.495 1.35.33.32.785.48 1.365.48h7.74zm-.93-12.24h-4.89V19h4.89c1.34 0 2.34.24 3 .72.66.48.99 1.22.99 2.22 0 1.98-1.33 2.97-3.99 2.97zm-4.89 9.24h5.4c1.4 0 2.42-.25 3.06-.75.64-.5.96-1.28.96-2.34 0-1.06-.325-1.85-.975-2.37-.65-.52-1.665-.78-3.045-.78h-5.4v6.24z"
        fill={COLORS.debianRed}
      />
    </svg>
  );
};

export const EarlyAIcon = (): JSX.Element => {
  return (
    <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="27" cy="27" r="26" fill={COLORS.cadmiumViolet} stroke="#fff" strokeWidth="2" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.415 36.97c-.37.32-.795.48-1.275.48-.32 0-.62-.085-.9-.255-.28-.17-.5-.435-.66-.795l-1.8-4.02H22.22l-1.8 4.02c-.16.36-.38.625-.66.795-.28.17-.59.255-.93.255-.46 0-.88-.16-1.26-.48-.38-.32-.57-.71-.57-1.17 0-.26.06-.52.18-.78l8.28-17.79c.18-.4.455-.705.825-.915.37-.21.765-.315 1.185-.315.42 0 .815.105 1.185.315.37.21.645.515.825.915l8.31 17.79c.12.26.18.52.18.78 0 .46-.185.85-.555 1.17zM27.5 20.47l-3.96 8.91h7.92l-3.96-8.91z"
        fill="#fff"
      />
    </svg>
  );
};

export const EarlyBIcon = (): JSX.Element => {
  return (
    <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="27" cy="27" r="26" fill="#DCD4E7" stroke={COLORS.cadmiumViolet} strokeWidth="2" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.6 37.15c2.26 0 4.035-.51 5.325-1.53s1.935-2.43 1.935-4.23c0-1.3-.335-2.4-1.005-3.3-.67-.9-1.615-1.52-2.835-1.86 1.04-.38 1.855-.98 2.445-1.8.59-.82.885-1.79.885-2.91 0-1.74-.625-3.095-1.875-4.065C32.225 16.485 30.5 16 28.3 16h-7.44c-.58 0-1.035.16-1.365.48-.33.32-.495.77-.495 1.35v17.49c0 .58.165 1.03.495 1.35.33.32.785.48 1.365.48h7.74zm-.93-12.24h-4.89V19h4.89c1.34 0 2.34.24 3 .72.66.48.99 1.22.99 2.22 0 1.98-1.33 2.97-3.99 2.97zm-4.89 9.24h5.4c1.4 0 2.42-.25 3.06-.75.64-.5.96-1.28.96-2.34 0-1.06-.325-1.85-.975-2.37-.65-.52-1.665-.78-3.045-.78h-5.4v6.24z"
        fill={COLORS.cadmiumViolet}
      />
    </svg>
  );
};

export const DevelopingAIcon = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g transform="translate(-458.000000, -546.000000) translate(248.000000, 534.000000) translate(210.000000, 12.000000)">
              <circle cx="27" cy="27" r="26" fill="#00808D" stroke="#FFF" strokeWidth="2" />
              <path
                fill="#FFF"
                fillRule="nonzero"
                d="M35.576 37.12c.48 0 .905-.16 1.275-.48.37-.32.555-.71.555-1.17 0-.26-.06-.52-.18-.78l-8.31-17.79c-.18-.4-.455-.705-.825-.915-.37-.21-.765-.315-1.185-.315-.42 0-.815.105-1.185.315-.37.21-.645.515-.825.915l-8.28 17.79c-.12.26-.18.52-.18.78 0 .46.19.85.57 1.17.38.32.8.48 1.26.48.34 0 .65-.085.93-.255.28-.17.5-.435.66-.795l1.8-4.02h10.56l1.8 4.02c.16.36.38.625.66.795.28.17.58.255.9.255zm-4.68-8.07h-7.92l3.96-8.91 3.96 8.91z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const DevelopingBIcon = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="54"
      height="54"
      viewBox="0 0 54 54"
    >
      <defs>
        <path
          id="tl5fa7blpa"
          d="M28.6 37.15c2.26 0 4.035-.51 5.325-1.53s1.935-2.43 1.935-4.23c0-1.3-.335-2.4-1.005-3.3-.67-.9-1.615-1.52-2.835-1.86 1.04-.38 1.855-.98 2.445-1.8.59-.82.885-1.79.885-2.91 0-1.74-.625-3.095-1.875-4.065C32.225 16.485 30.5 16 28.3 16h-7.44c-.58 0-1.035.16-1.365.48-.33.32-.495.77-.495 1.35v17.49c0 .58.165 1.03.495 1.35.33.32.785.48 1.365.48h7.74zm-.93-12.24h-4.89V19h4.89c1.34 0 2.34.24 3 .72.66.48.99 1.22.99 2.22 0 1.98-1.33 2.97-3.99 2.97zm.51 9.24h-5.4v-6.24h5.4c1.38 0 2.395.26 3.045.78.65.52.975 1.31.975 2.37s-.32 1.84-.96 2.34c-.64.5-1.66.75-3.06.75z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g transform="translate(-934.000000, -546.000000) translate(731.000000, 534.000000) translate(203.000000, 12.000000)">
              <circle cx="27" cy="27" r="26" fill="#CFEEF1" stroke="#00727D" strokeWidth="2" />
              <g fillRule="nonzero">
                <use fill="ivory" xlinkHref="#tl5fa7blpa" />
                <use fill="#00727D" xlinkHref="#tl5fa7blpa" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const ConsolidatingAIcon = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g transform="translate(-458.000000, -714.000000) translate(248.000000, 702.000000) translate(210.000000, 12.000000)">
              <circle cx="27" cy="27" r="26" fill="#007EA7" stroke="#FFF" strokeWidth="2" />
              <path
                fill="#FFF"
                fillRule="nonzero"
                d="M36.14 37.45c.48 0 .905-.16 1.275-.48.37-.32.555-.71.555-1.17 0-.26-.06-.52-.18-.78l-8.31-17.79c-.18-.4-.455-.705-.825-.915-.37-.21-.765-.315-1.185-.315-.42 0-.815.105-1.185.315-.37.21-.645.515-.825.915l-8.28 17.79c-.12.26-.18.52-.18.78 0 .46.19.85.57 1.17.38.32.8.48 1.26.48.34 0 .65-.085.93-.255.28-.17.5-.435.66-.795l1.8-4.02h10.56l1.8 4.02c.16.36.38.625.66.795.28.17.58.255.9.255zm-4.68-8.07h-7.92l3.96-8.91 3.96 8.91z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const ConsolidatingBIcon = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g transform="translate(-934.000000, -714.000000) translate(732.000000, 702.000000) translate(202.000000, 12.000000)">
              <circle cx="27" cy="27" r="26" fill="#C9EDFB" stroke="#007095" strokeWidth="2" />
              <path
                fill="#007095"
                fillRule="nonzero"
                d="M28.6 37.15c2.26 0 4.035-.51 5.325-1.53s1.935-2.43 1.935-4.23c0-1.3-.335-2.4-1.005-3.3-.67-.9-1.615-1.52-2.835-1.86 1.04-.38 1.855-.98 2.445-1.8.59-.82.885-1.79.885-2.91 0-1.74-.625-3.095-1.875-4.065C32.225 16.485 30.5 16 28.3 16h-7.44c-.58 0-1.035.16-1.365.48-.33.32-.495.77-.495 1.35v17.49c0 .58.165 1.03.495 1.35.33.32.785.48 1.365.48h7.74zm-.93-12.24h-4.89V19h4.89c1.34 0 2.34.24 3 .72.66.48.99 1.22.99 2.22 0 1.98-1.33 2.97-3.99 2.97zm.51 9.24h-5.4v-6.24h5.4c1.38 0 2.395.26 3.045.78.65.52.975 1.31.975 2.37s-.32 1.84-.96 2.34c-.64.5-1.66.75-3.06.75z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const ExtendingAIcon = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g transform="translate(-458.000000, -882.000000) translate(248.000000, 870.000000) translate(210.000000, 12.000000)">
              <circle cx="27" cy="27" r="26" fill="#008746" stroke="#FFF" strokeWidth="2" />
              <path
                fill="#FFF"
                fillRule="nonzero"
                d="M36.14 37.45c.48 0 .905-.16 1.275-.48.37-.32.555-.71.555-1.17 0-.26-.06-.52-.18-.78l-8.31-17.79c-.18-.4-.455-.705-.825-.915-.37-.21-.765-.315-1.185-.315-.42 0-.815.105-1.185.315-.37.21-.645.515-.825.915l-8.28 17.79c-.12.26-.18.52-.18.78 0 .46.19.85.57 1.17.38.32.8.48 1.26.48.34 0 .65-.085.93-.255.28-.17.5-.435.66-.795l1.8-4.02h10.56l1.8 4.02c.16.36.38.625.66.795.28.17.58.255.9.255zm-4.68-8.07h-7.92l3.96-8.91 3.96 8.91z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const ExtendingBIcon = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g transform="translate(-934.000000, -882.000000) translate(732.000000, 870.000000) translate(202.000000, 12.000000)">
              <circle cx="27" cy="27" r="26" fill="#E0ECAB" stroke="#00753D" strokeWidth="2" />
              <path
                fill="#00753D"
                fillRule="nonzero"
                d="M28.6 37.15c2.26 0 4.035-.51 5.325-1.53s1.935-2.43 1.935-4.23c0-1.3-.335-2.4-1.005-3.3-.67-.9-1.615-1.52-2.835-1.86 1.04-.38 1.855-.98 2.445-1.8.59-.82.885-1.79.885-2.91 0-1.74-.625-3.095-1.875-4.065C32.225 16.485 30.5 16 28.3 16h-7.44c-.58 0-1.035.16-1.365.48-.33.32-.495.77-.495 1.35v17.49c0 .58.165 1.03.495 1.35.33.32.785.48 1.365.48h7.74zm-.93-12.24h-4.89V19h4.89c1.34 0 2.34.24 3 .72.66.48.99 1.22.99 2.22 0 1.98-1.33 2.97-3.99 2.97zm.51 9.24h-5.4v-6.24h5.4c1.38 0 2.395.26 3.045.78.65.52.975 1.31.975 2.37s-.32 1.84-.96 2.34c-.64.5-1.66.75-3.06.75z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
